import React from "react";
import dashBoardBG from "../../assets/FootprintDashboard/dashboardBG.png";
import mobileSS from "../../assets/FootprintDashboard/mobileSS.png";
import charts from "../../assets/FootprintDashboard/dashboardCharts.png";
import { Box, styled, Typography } from "@mui/material";
import { Padding } from "@mui/icons-material";

const CalculateFootprintDashboard = () => {
  return (
    <Box component="section">
      <FootprintBannerContainer>
        <FootprintContentContainer>
          <FootprintContent>
            <Typography
              variant="h4"
              align="center"
              sx={{
                color: "#fff",
                fontWeight: "600",
                fontFamily: "Houschka Rounded Alt",
              }}
            >
              Tracking your
            </Typography>
            <Typography
              variant="h4"
              align="center"
              sx={{
                color: "#fff",
                fontWeight: "600",
                fontFamily: "Houschka Rounded Alt",
              }}
            >
              Carbon Footprint
            </Typography>
            <Typography
              textAlign="center"
              sx={{ width: { sm: "90%", md: "70%" }, color: "#fff" }}
            >
              Track your daily carbon footprint by logging your journeys. Choose
              your commute method—bus, car, bike, or walk— and see your CO₂e
              emissions for each trip.
            </Typography>
          </FootprintContent>
        </FootprintContentContainer>
        <MobileImageContainer>
          <MobileImage
            src={mobileSS}
            alt="Carbon footprint tracker from C4L Application"
          />
        </MobileImageContainer>
      </FootprintBannerContainer>
      <DashboardContainer>
        <DashBoardImage src={charts} alt="sample footprint dashboard" />
        <DashboardContent>
          <Typography
            variant="h4"
            align="center"
            sx={{
              color: "#fff",
              fontWeight: "600",
              fontFamily: "Houschka Rounded Alt",
            }}
          >
            Daily Footprint
          </Typography>
          <Typography
            variant="h4"
            align="center"
            sx={{
              color: "#fff",
              fontWeight: "600",
              fontFamily: "Houschka Rounded Alt",
            }}
          >
            Dashboard
          </Typography>
          <Typography
            sx={{
              color: "#fff",
            }}
          >
            Track your daily CO₂e emissions and journey history. View a
            breakdown of each trip and monitor your impact to make greener
            choices.
          </Typography>
        </DashboardContent>
      </DashboardContainer>
    </Box>
  );
};

export default CalculateFootprintDashboard;

const FootprintBannerContainer = styled("div")({
  backgroundImage: `url(${dashBoardBG})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  width: "100%",
  height: "500px",
  display: "flex",
  flexWrap: "wrap",
});

const FootprintContentContainer = styled("div")({
  width: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",

  "@media (max-width: 768px)": {
    width: "100%",
  },
});

const MobileImageContainer = styled("div")({
  width: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",

  "@media (max-width: 768px)": {
    display: "none",
  },
});

const MobileImage = styled("img")({
  width: "70%",
  height: "100%",
});

const FootprintContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

const DashboardContainer = styled("div")({
  backgroundColor: "#171717",
  display: "flex",
  justifyContent: "center",
  gap: "10%",
  flexWrap: "wrap",

  "@media (max-width: 768px)": {
    // display: "none",
    flexDirection: "column-reverse",
    alignItems: "center",
  },
});

const DashBoardImage = styled("img")({
  width: "40%",
  "@media (max-width: 768px)": {
    height: "300px",
    width: "80%",
  },
});

const DashboardContent = styled("div")({
  width: "30%",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  flexDirection: "column",
  gap: "10px",
  "@media (max-width: 768px)": {
    width: "80%",
    padding: "20px",
  },
});
